import { Navbar } from "@/components/layout/Navbar";
import { Hero } from "@/components/landing/Hero";
import { Features } from "@/components/landing/Features";
import { HowItWorks } from "@/components/landing/HowItWorks";
import { CTA } from "@/components/landing/CTA";
import { Footer } from "@/components/layout/Footer";
import { PageHead } from "@/components/seo/PageHead";

const Index = () => {
  return (
    <div className="min-h-screen bg-background">
      <PageHead
        title="JP Remote — AI Remote Jobs & Telegram Bot"
        description="Find remote jobs faster with an AI-powered Telegram bot, smart alerts, AI CV tools, and unlimited PRO browsing. Worldwide remote roles."
        path="/"
      />
      <Navbar />
      <Hero />
      <Features />
      <HowItWorks />
      <CTA />
      <Footer />
    </div>
  );
};

export default Index;
